<template>
  <div style="height: 100vh;" class="c-white-background">
    <MainNavBarWapV2 :object-data="infoHeader" />
    <div
      class="full-width  container-history top-spacing"
      v-loading="isLoading"
      style="display: flex; justify-content: center; flex-direction: column;"
    >
      <div
        v-for="item in paymentMethods"
        :key="item.id"
        style="display: flex; flex-direction: row; justify-content: space-between; align-items: center; background-color: white; margin: 10px 15px; padding: 1rem 15px; border-radius: 10px; min-height: 85px; height: auto;"
      >
        <div
          @click="mappingMethods[item.type].handler()"
          class="cursor-pointer"
          style="display: flex; flex-direction: row; align-items: center;"
        >
          <img
            :src="item.image"
            style="width: 42px; height: 42px; margin: 10px 7px;"
          />
          <div style="display: flex; flex-direction: column; margin-left: 8px">
            <p style="margin: 0px; font-weight: 700; font-size: large;">
              {{ item.name }}
            </p>
            <p
              v-if="mappingMethods[item.type].showPoint"
              style="margin: 0px; font-weight: 500; font-size: medium;"
            >
              {{ $t("wap.text74") }}:
              <span style="color: blue"
                >{{ formatNumber($store.getters.point) }} VND</span
              >
            </p>
            <p style="margin: 0px; font-weight: 500; font-size: medium;">
              {{ $t("wap.text75") }}:
              <span style="color: chocolate"
                >{{ formatNumber(moneyPaid) }} VND</span
              >
            </p>
            <span
              v-if="mappingMethods[item.type].note"
              class="note-payment-method"
              >{{ mappingMethods[item.type].note }}</span
            >
          </div>
        </div>
        <i
          @click="mappingMethods[item.type].handler()"
          class="el-icon-arrow-right"
          style="font-weight: 700; font-size: larger;"
        ></i>
      </div>
    </div>
  </div>
</template>
<script>
import { getDepositAmount } from "@/utils/booked";
import GlobalAPI from "@/views/api/wap/global";
import MainNavBarWapV2 from "@/layout/WapV2/MainNavBar.vue";
import { MessageBox } from "element-ui";

export default {
  name: "PaymentMethod",
  components: {
    MainNavBarWapV2
  },
  created() {
    const constMethods = {
      bank: {
        showPoint: false,
        handler: this.handleBank,
        note: null
      },
      epay_all: {
        showPoint: false,
        handler: this.handleEpay,
        title: this.$t("wap.text131"),
        note: this.$t("wap.text129")
      },
      ale_pay: {
        showPoint: false,
        handler: this.handleAlePay,
        title: this.$t("wap.text184"),
        note: this.$t("wap.text129")
      },
    };
    this.mappingMethods = constMethods;
    this.getPaymentMethod();
  },
  mounted() {},
  data() {
    return {
      infoHeader: {
        title: this.$t("wap.text124"),
        isShowHomeIcon: false
      },
      loadingMethod: false,
      isLoading: false,
      idInterval: null,
      isShowModal: false,
      dialogLoginVisible: false,
      transactionVisible: false,
      defaultBackgroundColor: "",
      params: {},
      paymentMethods: [],
      mappingMethods: {},
      transactionData: {},
      moneyPaid: this.$route.params.payment_amount || getDepositAmount(),
      profile: {},
      dataResult: {},
      typePayment: "point"
    };
  },
  beforeDestroy() {},
  methods: {
    formatNumber: function(number) {
      return new Intl.NumberFormat("vi-VN")
        .format(number)
        .split(".")
        .join(".");
    },
    handleBank() {
      if (this.moneyPaid < 150000) {
        this.$message.error(`${this.$t("wap.text123")} 150.000đ.`);
        return;
      }
      this.$router.push({
        name: "wap-wallet-qr-payment",
        params: { payment_amount: this.moneyPaid }
      });
    },
    handleEpay() {
      if (this.moneyPaid < 150000) {
        this.$message.error(`${this.$t("wap.text123")} 150.000đ.`);
        return;
      }
      const body = {
        money: this.moneyPaid,
        data_provider: { amount: this.moneyPaid },
        provider: "point_new",
        type: "epay_all"
      };
      this.isLoading = true;
      GlobalAPI.create_request_for_wap_point(body)
        .then(res => {
          const { error_code, data, error_msg } = res;
          if (error_code !== 0) {
            this.$message.error(error_msg);
          } else {
            if (data.epay_link) {
              this.isLoading = false;
              MessageBox.confirm(
                this.$t("wap.ConfirmRedirectEpay"),
                this.$t("wap.Confirm"),
                {
                  confirmButtonText: this.$t("wap.Confirm"),
                  cancelButtonText: this.$t("wap.back"),
                  type: "warning"
                }
              )
                .then(() => {
                  window.open(data.epay_link, "_blank");
                })
                // .catch((e) => {
                //   this.$message.error(e.message);
                // });
          }
            
          }
        })
    },
    handleAlePay() {
      if (this.moneyPaid < 150000) {
        this.$message.error(`${this.$t("wap.text123")} 150.000đ.`);
        return;
      }
      const body = {
        money: this.moneyPaid,
        data_provider: { amount: this.moneyPaid },
        provider: "point_new",
        type: "ale_pay"
      };
      this.isLoading = true;
      GlobalAPI.create_request_for_wap_point(body)
        .then(res => {
          const { error_code, data, error_msg } = res;
          if (error_code !== 0) {
            this.$message.error(error_msg);
          } else {
            if (data.ale_pay_link) {
              this.isLoading = false;
              MessageBox.confirm(
                this.$t("wap.ConfirmRedirectAlePay"),
                this.$t("wap.Confirm"),
                {
                  confirmButtonText: this.$t("wap.Confirm"),
                  cancelButtonText: this.$t("wap.back"),
                  type: "warning"
                }
              )
                .then(() => {
                  window.open(data.ale_pay_link, "_blank");
                })
                // .catch((e) => {
                //   this.$message.error(e.message);
                // });
          }
            
          }
        })
    },
    getPaymentMethod() {
      this.loadingMethod = true;
      GlobalAPI.list_method_payment({ version: 1 })
        .then(res => {
          const { error_code, data, error_msg } = res;
          if (error_code !== 0) {
            return;
          } else {
            this.paymentMethods = res.data.filter(i =>
              ["bank", 'epay', 'epay_all', 'ale_pay'].includes(i.type)
            );
          }
        })
        .finally(() => {
          this.loadingMethod = false;
        });
    }
  }
};
</script>
<style scoped>
.top-spacing {
  padding-top: 100px;
}
.note-payment-method {
  margin: 0px;
  font-weight: 500;
  font-size: medium;
  color: #e31d1d;
  line-height: 1;
}
::v-deep .el-dialog__wrapper {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  height: 100% !important;
}
.modal-logout {
  background: rgba(0, 0, 0, 0.6);
  height: 100vh;
  z-index: 4;
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
}
.modal-logout-title {
  font-family: "SF Pro Display";
  font-size: 20px;
  font-weight: 700;
  line-height: 23.87px;
  text-align: center;
  color: #000;
  margin: 0;
}
.modal-logout-body {
  text-align: start;
  color: rgba(0, 0, 0, 1);
  font-family: "SF Pro Display";
  font-size: 15px;
  font-weight: 400;
  line-height: 18px;
  text-align: left;
}

.modal-logout-body-content span {
  font-weight: 500;
  color: #999999;
}
.modal-logout-footer {
  justify-content: center;
  display: flex;
  width: 100%;
}

.modal-logout-footer .close {
  border-radius: 8px;
  border: 1px solid rgba(23, 71, 158, 1);
  width: 50%;
  height: 40px;
  color: rgba(23, 71, 158, 1);
  font-family: "SF Pro Display";
  font-size: 14px;
  font-weight: 600;
  line-height: 16.71px;
  text-align: center;
  margin-right: 30px;
}

.modal-logout-footer .logout-form {
  border-radius: 8px;
  background-color: rgba(23, 71, 158, 1);
  width: 50%;
  height: 40px;
  color: rgb(255, 255, 255);
  font-family: "SF Pro Display";
  font-size: 14px;
  font-weight: 600;
  line-height: 16.71px;
  text-align: center;
}
.modal-logout > footer {
  justify-content: space-between;
  padding: 0;
}
.container-history {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  max-width: 900px;
}
@media screen and (min-width: 0px) and (max-width: 980px) {
  .top-spacing {
    padding-top: 65px;
  }
}
</style>
